import { render, staticRenderFns } from "./event-stats.vue?vue&type=template&id=85a478b0&scoped=true&lang=pug"
import script from "./event-stats.vue?vue&type=script&lang=coffee"
export * from "./event-stats.vue?vue&type=script&lang=coffee"
import style0 from "./event-stats.vue?vue&type=style&index=0&id=85a478b0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a478b0",
  null
  
)

export default component.exports